module.exports = __webpack_public_path__ + "media/Text_left.5e5fc0c4.mp4";